var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPremisesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.333,12.333v7.333h7.333V12.333Zm-1-2.333A1.333,1.333,0,0,0,10,11.333v9.333A1.333,1.333,0,0,0,11.333,22h9.333A1.333,1.333,0,0,0,22,20.667V11.333A1.333,1.333,0,0,0,20.667,10ZM27,12.333v7.333h7.333V12.333ZM26,10a1.333,1.333,0,0,0-1.333,1.333v9.333A1.333,1.333,0,0,0,26,22h9.333a1.333,1.333,0,0,0,1.333-1.333V11.333A1.333,1.333,0,0,0,35.334,10ZM12.333,34.334V27h7.333v7.333ZM10,26a1.333,1.333,0,0,1,1.333-1.333h9.333A1.333,1.333,0,0,1,22,26v9.333a1.333,1.333,0,0,1-1.333,1.333H11.333A1.333,1.333,0,0,1,10,35.334Zm20.667-1.167A1.166,1.166,0,0,1,31.834,26v3.583h3.583a1.167,1.167,0,1,1,0,2.333H31.834V35.5a1.167,1.167,0,0,1-2.333,0V31.917H25.917a1.167,1.167,0,1,1,0-2.333H29.5V26A1.166,1.166,0,0,1,30.667,24.834Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPremisesIcon);
export default __webpack_public_path__ + "static/media/add-premises-icon.c6b3c9aef54739bc0361388bccd5925a.svg";
export { ForwardRef as ReactComponent };